/**
 * # Offset Position
 * Get the offset position of the element.
 *
 * @param {Element} el
 * @param {Boolean} viewPortOffset The offset relative to the viewport, not page.
 * @return {Object}
 *
 * @module helpers/dom/offset.js
 */
function offset(el, viewPortOffset) {
  if (typeof window === "undefined") return false;

  let rect = {
    top: 0,
    left: 0,
    width: 0,
  };

  if (!("getBoundingClientRect" in el)) {
    return rect;
  }

  // Native implementation
  if (el.getBoundingClientRect) {
    let bounding = el.getBoundingClientRect();
    rect.left = bounding.left;
    rect.top = bounding.top;
    rect.width = bounding.width || 0;

    if (!viewPortOffset) {
      rect.left +=
        typeof window.scrollX !== "undefined"
          ? window.scrollX
          : window.pageXOffset;
      rect.top +=
        typeof window.scrollY !== "undefined"
          ? window.scrollY
          : window.pageYOffset;
    }
  } else {
    let x = 0,
      y = 0,
      z = 0;
    do {
      x += el.offsetLeft - (!viewPortOffset ? el.scrollLeft : 0);
      y += el.offsetTop - (!viewPortOffset ? el.scrollTop : 0);
      z += el.offsetWidth || 0;
    } while ((el = el.offsetParent));

    rect.left = x;
    rect.top = y;
    rect.width = z;
  }

  return rect;
}

export default offset;
